import { GET, POST, DELETE, PATCH } from '../util/fetch-methods'
import fetch from 'isomorphic-fetch'
import appendQuery from 'append-query'
import * as urlUtil from 'url'
export const relatedUrl = (gifId, page = 1) => `/gifs/${gifId}/related/${page}`
export const gifUrl = gifId => `/gifs/${gifId}/`
export const gceUrl = '//rxjthjm1pofte.com'
export const imagingUrl = '//imaging.giphy.com'
import { ResponseError } from './errors'

const trendingApiUrl = '//x.giphy.com/v1/stories/trending'

export const MOBILE_API_KEY = `L8eXbxrbPETZxlvgXN9kIEzQ55Df04v0`
export const WEB_API_KEY = `Gc7131jiJuvI7IdN0HZ1D7nh0ow5BU6g`
export const TAGGER_API_KEY = `MviND4Ir2kESI`

const checkStatus = res => {
    const { status, ok } = res
    if (status === 204) {
        return ok
    }
    if (status >= 200 && status < 300) {
        return res
    }

    return res.json().then(fieldErrors => {
        throw new ResponseError(res, fieldErrors)
    })
}

export const request = (url, config, token) => {
    if (token) {
        const { headers } = config
        config['headers'] = { ...headers, Authorization: `Token ${token}` }
    }
    return fetch(url, config)
        .then(checkStatus)
        .then(response => response.json())
        .catch(err => console.error(err))
}
const getResults = (...request) => {
    return fetch(...request)
        .then(checkStatus)
        .then(response => (response.json ? response.json() : response))
        .then(({ status, result, ...whatever }) => {
            if (!result) {
                // just return the whole response object
                return whatever
            }
            // some responses have a nested "result"
            return { status, ...result }
        })
}

const VIDEO_API = `//x.giphy.com/v1/videos`
export const getVideos = (params = {}) =>
    getResults(
        appendQuery(VIDEO_API, {
            exact_tag_match: true,
            match_method: 'AND',
            api_key: WEB_API_KEY,
            ...params,
        }),
    )
export const getVideo = id =>
    getResults(
        appendQuery(`${VIDEO_API}/${id}`, {
            api_key: WEB_API_KEY,
        }),
    )

export const login = () => getResults(`/login/check`, GET)

export const instagram = (gifId, email) => fetch(`/ajax/instashare/`, POST({ gif_id: gifId, to: email }, true))

export function follow(userId) {
    return getResults(`/users/${userId}/follows`, POST())
}

export function unfollow(userId) {
    return getResults(`/users/${userId}/follows`, DELETE())
}

export function follows() {
    return getResults('/users/self/follows', GET)
}

export function getNewPermissions(gifId) {
    return getResults(`/ajax/gif/${gifId}/detail`, GET)
}

export async function gifs(url, processor, pingback_id, apiKey) {
    const urlToFetch = appendQuery(url, {
        is: 1,
        json: true,
        pingback_id,
        api_key: apiKey,
    })
    const res = await fetch(urlToFetch, GET)
    if (res.ok) {
        let json
        try {
            json = await res.json()
        } catch (e) {
            throw `Error parsing json for ${url}`
        }
        return processor(json, pingback_id, url, apiKey)
    }
}

export const getArtistChannels = (filter = '') => getResults(appendQuery(`/api/v1/artists/`, { filter }), GET)

export function getChannelById(channelId = '') {
    return getResults(`/api/v1/channels/${channelId}/`, GET)
}

export function createChannel(channel) {
    return getResults(`/api/v1/channels/`, POST(channel, true))
}

export function moveChannel(channelId, siblingId, side) {
    return getResults(`/api/v1/channels/${channelId}/move/`, POST({ position: side, target_channel: siblingId }, true))
}

export function editChannelById(channelId, channel, isJson) {
    return getResults(`/api/v1/channels/${channelId}/`, PATCH(channel, isJson))
}

export function deleteChannelById(channelId = '') {
    return getResults(`/api/v1/channels/${channelId}/`, DELETE())
}

export function searchUsername(userName = '') {
    return getResults(`/api/v1/users/?search=${userName}`, GET)
}

export function getUserById(userId = '') {
    return getResults(`/api/v1/users/${userId}/`, GET)
}

export function editUserById(userId, user, isJson) {
    return getResults(`/api/v1/users/${userId}/`, PATCH(user, isJson))
}

export function createRankedTag(tag) {
    return getResults(`/api/v1/channel-ranked-tags/`, POST(tag, true))
}

export function editRankedTag(tagId, rank) {
    return getResults(`/api/v1/channel-ranked-tags/${tagId}/`, PATCH(rank, true))
}

export function deleteRankedTag(tagId) {
    return getResults(`/api/v1/channel-ranked-tags/${tagId}/`, DELETE())
}

export function createSyncableTag(tag) {
    return getResults(`/api/v1/channel-magic-tags/`, POST(tag, true))
}

export function deleteSyncableTag(tagId) {
    return getResults(`/api/v1/channel-magic-tags/${tagId}/`, DELETE())
}

export function search(term) {
    return getResults(`/ajax/tags/search/?q=${term}`, GET).then(({ objects }) => objects)
}

export function channelSearch(query) {
    return getResults(`/api/v1/channels-search/search/channel_v2?q=${query}`, GET).then(({ hits }) => hits)
}

export function channelSocialSearch(query) {
    return getResults(`/api/v1/channels-search/search/social?q=${query}`, GET).then(({ hits }) => hits)
}

export function getSuggestedSearchTerms(query) {
    return getResults(`/api/v1/tags/significant?q=${query}`)
}

export function fetchUserAnalytics(userId) {
    return getResults(`/api/v1/users/${userId}/view-count/`, GET)
}

export function fetchGifDetailViewCount(id) {
    return getResults(`/api/v1/proxy-gif/${id}/view-count/`, GET)
}

export function getGifById(gifId) {
    return getResults(appendQuery(`//api.giphy.com/v1/gifs/${gifId}`, { api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x' }))
}

export function getGifsById(gifIds) {
    return getResults(
        appendQuery(`//api.giphy.com/v1/gifs`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
            ids: Array.isArray(gifIds) ? gifIds.join(',') : gifIds,
        }),
    )
}

export function fetchTagCounts(gifId) {
    return getResults(`/ajax/gif/${gifId}/tag-counts`, GET)
}

export function fetchExtendedMetadata(gifId) {
    return getResults(`/ajax/gif/${gifId}/extended-metadata`, GET)
}

export function channelGifs(channelId, maxId) {
    return getResults(`/api/v1/channels/${channelId}/gifs/?max_id=${maxId}`, GET)
}

export function trackGifShare(id, type) {
    return fetch(`/ajax/gif/${id}/analytic/${type}`, POST())
}

export function tweet(formData) {
    return getResults('/ajax/twitter_upload', POST(formData))
}

export function fetchChannel(id = '') {
    return getResults(`/ajax/channels/${id}/`, GET)
}

export function allChannelSearch(slug = '') {
    return getResults(`/api/v1/channels/?search=${slug}`, GET)
}

export function updateGif(gifId, prop, value) {
    const params = {
        gif_id: gifId,
        key: prop,
        value,
    }
    return getResults('/ajax/gif/update', POST(params, true))
}

export function toggleFavorite(gifId) {
    return getResults(`/favorites/${gifId}/`, POST())
}

export function favoriteMilestones() {
    return fetch('/api/v1/favorite-milestones/', GET)
        .then(checkStatus)
        .then(response => response.json())
}

export function gifShortener(formData) {
    return getResults('/ajax/shorturl/create/', POST(formData))
}

export function giphyAnalytics(shareType, gifId) {
    return getResults(`/ajax/gif/${gifId}/analytic/${shareType}/`, POST())
}

export function updateChannelGif(gifId, channelId, isDelete) {
    const params = {
        channel: channelId,
        gif: gifId,
    }
    return getResults(`/api/v1/channel-gifs/${isDelete ? 'remove/' : ''}`, POST(params, true))
}

export const channels = () => request(`/api/v1/channels/`, GET)

export const channelChildren = id => {
    if (!id) {
        throw new Error("We cannot fetch a channel's children without its parent's id.")
    }
    return request(`/api/v1/channels/?parent=${id}`, GET)
}

export const flag = (gifId, body) => request(`/api/v1/gifs/${gifId}/moderation`, POST(body))

export const getVideoEmbedInfo = url => getResults(`${imagingUrl}/fetch/video/info?url=${encodeURIComponent(url)}`, GET)

export const trimVideoEmbed = (url, start, duration) =>
    fetch(
        appendQuery(`${imagingUrl}/imaging/trim`, {
            media_url: url,
            start,
            duration,
        }),
        GET,
    )

export const getModerationGifs = (minId, maxId) =>
    getResults(appendQuery('/api/v1/moderation/gifs/', { min_id: minId, max_id: maxId }), GET)

export const getModerationBatchAction = userId =>
    getResults(
        appendQuery(`/api/v1/moderation/gif-batch-actions/`, {
            user_id: userId,
            action: 'assigned',
        }),
        GET,
    )

export const setModerationBatchAction = (actionId, action) =>
    getResults(`/api/v1/moderation/gif-batch-actions/${actionId}/`, PATCH({ action }, true))

export const createModerationBatchAction = jobId =>
    getResults(`/api/v1/moderation/gif-batch-actions/`, POST(jobId ? { job_id: jobId } : null, !!jobId))

export const fetchModerationLeaderboard = jobId =>
    getResults(appendQuery('/api/v1/moderation/gif-batch-actions/leaderboard/', jobId ? { job_id: jobId } : null), GET)

export const searchService = params =>
    getResults(appendQuery('/api/v1/search-service/search/', params, { encodeComponents: false }), GET)

export const getStoryById = (id, token) =>
    getResults(
        appendQuery(`//x.giphy.com/v1/stories/${id}`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: 'get',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )
export const getStory = (slug, token) =>
    getResults(
        appendQuery(`//x.giphy.com/v1/stories/slug/${slug}`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: 'get',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )

export const saveStory = (story, token) => {
    const isUpdate = !!story.story_id
    return getResults(
        appendQuery(`//x.giphy.com/v1/stories${isUpdate ? '/' + story.story_id : ''}`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: isUpdate ? 'put' : 'post',
            body: JSON.stringify({ story }),
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )
}

export const deleteStory = (storyId, token) =>
    getResults(
        appendQuery(`//x.giphy.com/v1/stories/${storyId}`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: 'delete',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )

export const getUserStories = (username, token, showUnpublished = false) => {
    if (!username) {
        console.error(`No username specified for getUserStories`)
        return
    }
    return getResults(
        appendQuery('//x.giphy.com/v1/stories', {
            username,
            test: 'cachebust',
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
            fetch_unpublished: showUnpublished,
        }),
        {
            method: 'get',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )
}

export const getArtistAndPartnerStories = (token, since, until) => {
    const params = {
        limit: 50,
        api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
    }

    if (since) {
        params.since = since
    }

    if (until) {
        params.until = until
    }

    return getResults(appendQuery('//x.giphy.com/v1/stories/partnerArtist', params), {
        method: 'get',
        headers: token
            ? {
                  Accept: 'application/json',
                  Authorization: `Token ${token}`,
              }
            : {},
    })
}

export const getTrendingStories = (token, sort = 'desc') =>
    getResults(
        appendQuery(trendingApiUrl, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
            sort,
        }),
        {
            method: 'get',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )

export const getStoriesByUrl = (url, token) =>
    getResults(url, {
        method: 'get',
        headers: token
            ? {
                  Accept: 'application/json',
                  Authorization: `Token ${token}`,
              }
            : {},
    })

export const saveTrendingStory = (storyId, trendingDatetime, token) =>
    getResults(
        appendQuery(trendingApiUrl, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: 'post',
            body: JSON.stringify({ trending_story: { story_id: storyId, publish_datetime: trendingDatetime } }),
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )

export const removeTrendingStory = (trendingId, token) =>
    getResults(
        appendQuery(`${trendingApiUrl}/${trendingId}`, {
            api_key: '3eFQvabDx69SMoOemSPiYfh9FY0nzO9x',
        }),
        {
            method: 'delete',
            headers: token
                ? {
                      Accept: 'application/json',
                      Authorization: `Token ${token}`,
                  }
                : {},
        },
    )
/**
 * @param {String} pathname pathname appended to https://api.giphy.com
 * @param {Object} query query params
 * @returns {Promise}
 */
export default (pathname, query = {}) =>
    fetch(
        urlUtil.format({
            protocol: `https`,
            host: `api.giphy.com`,
            pathname,
            query: { api_key: '5nt3fDeGakBKzV6lHtRM1zmEBAs6dsIc', ...query },
        }),
    )
        .then(checkStatus)
        .then(response => response.json())
